import React, { useState, useEffect } from 'react';
import moment from 'moment';
import MeetingsEventModal from './meetingeventmodal';
import EventModal from 'pages/adminCalender/pages/organisation-calendar/components/eventModal';
import { ReactComponent as NextIcon } from '../../../../assets/icons/rightSideArrow.svg';
import { ReactComponent as PrevIcon } from '../../../../assets/icons/leftSideArrow.svg';
import { ReactComponent as DropIcon } from '../../../../assets/icons/downArrow.svg';
import { Switch, Select } from '@mantine/core';
import PrimaryButton from 'components/primaryButton';

export default function MeetingToolbar(props) {
  const [openMeetingModal, setOpenMeetingModal] = useState(false);
  const [openEventModal, setOpenEventModal] = useState(false);
  const [drop, setDrop] = useState('Work week view');
  const [checked, setChecked] = useState(false);

  const handleChange = () => {
    if (checked) {
      props.onView('month');
    } else {
      handleSwitchCheck();
    }
  };

  const handleSwitchCheck = () => {
    if (drop === 'Work week view') {
      props.onView('work_week');
    } else if (drop === 'Weekly view') {
      props.onView('week');
    } else if (drop === 'Day view') {
      props.onView('day');
    }
  };

  const handleDropDown = (e) => {
    setDrop(e);
    handleMonthCheck();
  };

  const handleMonthCheck = () => {
    setChecked(true);
  };

  useEffect(() => {
    if (drop === 'Work week view' && checked) {
      props.onView('work_week');
    } else if (drop === 'Weekly view' && checked) {
      props.onView('week');
    } else if (drop === 'Day view' && checked) {
      props.onView('day');
    }
  }, [drop, props, checked]);

  // const goToToday = () => {
  //   const now = new Date();
  //   props.date.setMonth(now.getMonth());
  //   props.date.setYear(now.getFullYear());
  //   props.date.setDate(now.getDate());
  //   props.onNavigate("current");
  // };
  // const day = () => {
  //   const date = moment(props.date);
  //   // const currentDay = date.
  // };
  const date = moment(props.date);
  const daySelected = date.format('DD');
  const month = () => {
    const date = moment(props.date);
    const day = date.format('DD');
    let month = date.format('MMMM');
    // let year = date.format('YYYY');

    if (props?.view === 'day') {
      return (
        <span className='rbc-toolbar-label rbc-date'>
          <span>{`${day} ${month}`}</span>
        </span>
      );
    }

    return (
      <span className='rbc-toolbar-label rbc-date'>
        <span>{`${month}`}</span>
      </span>
    );
  };

  const getCustomToolbar = () => {
    const goToMonthView = () => {
      props.onView('month');
      setChecked(false);
    };
    // const goToWeekView = () => {
    //   props.onView("week");
    // };
    // const goToDayView = () => {
    //   props.onView("day");
    // };
    // const goToAgendaView = () => {
    //   props.onView("agenda");
    // };
    const goToBack = () => {
      let view = props?.view;
      let mDate = props.date;
      let newDate;
      if (view === 'month' || view === 'work_week') {
        newDate = new Date(mDate.getFullYear(), mDate.getMonth() - 1, 1);
      } else if (view === 'week') {
        newDate = new Date(
          mDate.getFullYear(),
          mDate.getMonth(),
          mDate.getDate() - 7,
          1
        );
      } else {
        newDate = new Date(
          mDate.getFullYear(),
          mDate.getMonth(),
          mDate.getDate() - 1,
          1
        );
      }
      props.onNavigate('prev', newDate);
    };

    const goToNext = () => {
      let view = props?.view;
      let mDate = props.date;
      let newDate;
      if (view === 'month' || view === 'agenda') {
        newDate = new Date(mDate.getFullYear(), mDate.getMonth() + 1, 1);
      } else if (view === 'week') {
        newDate = new Date(
          mDate.getFullYear(),
          mDate.getMonth(),
          mDate.getDate() + 7,
          1
        );
      } else {
        newDate = new Date(
          mDate.getFullYear(),
          mDate.getMonth(),
          mDate.getDate() + 1,
          1
        );
      }
      props.onNavigate('next', newDate);
    };

    return (
      <div className='rbc-toolbar block border-none'>
        <div className='rbc-toolbar-item-2 flex items-center justify-between'>
          <div className='rbc-btn-group flex items-center'>
            <span>
              <PrevIcon
                className='cursor-pointer 3xl:w-4 3xl:h-7'
                onClick={goToBack}
              />
            </span>
            <span
              className='text-primary cursor-default font-bold text-22 3xl:text-3xl'
              onClick={goToMonthView}
            >
              {month()}
            </span>
            <span>
              <NextIcon
                className='cursor-pointer 3xl:w-4 3xl:h-7'
                onClick={goToNext}
              />
            </span>
          </div>
          <div className='flex gap-x-3'>
            <div className='rbc-btn-group flex items-center gap-x-6'>
              <span className='label-filter-off   3xl:text-2xl'>
                Monthly view
              </span>
              <Switch
                color='primary'
                checked={checked}
                onChange={(e) => {
                  handleChange();
                  setChecked(e.currentTarget.checked);
                }}
                classNames={{
                  input: '3xl:w-11 3xl:h-6',
                }}
                // styles={{
                //   input: { transform: 'translateX(25px)' },
                // }}
              />
              <div className='flex items-center gap-x-1 cursor-pointer  '>
                <Select
                  className=''
                  onChange={(e) => handleDropDown(e)}
                  rightSection={<DropIcon size={14} />}
                  rightSectionWidth={70}
                  classNames={{
                    input: '3xl:text-2xl',
                  }}
                  defaultValue='Work week view'
                  styles={{
                    rightSection: { pointerEvents: 'none' },
                    input: {
                      border: 'none',
                      fontSize: '16px',
                      paddingRight: '0',
                    },
                  }}
                  data={[
                    { value: 'Work week view', label: 'Work week view' },
                    { value: 'Weekly view', label: 'Weekly view' },
                    { value: 'Day view', label: 'Day view' },
                  ]}
                />
              </div>
            </div>

            <div onClick={() => setOpenEventModal(true)}>
              <PrimaryButton> + Add an event </PrimaryButton>
            </div>
            <div onClick={() => setOpenMeetingModal(true)}>
              <PrimaryButton>Schedule a meeting</PrimaryButton>
            </div>
          </div>
        </div>

        <MeetingsEventModal
          openModal={openMeetingModal}
          setOpenModal={setOpenMeetingModal}
          modalTitle={'Schedule a meet'}
          clickedDate={daySelected}
          date={props.date}
          view={props.view}
        />
        <EventModal
          openModal={openEventModal}
          setOpenModal={setOpenEventModal}
          modalTitle={'Add an event'}
        />
      </div>
    );
  };

  return <>{getCustomToolbar()}</>;
}
